import React from 'react';

export default function SwitchOffIcon() {
	return (
		<svg width="53"
			height="32"
			viewBox="0 0 53 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect x="0.5"
				width="52"
				height="32"
				rx="16"
				fill="#21253C"/>
			<rect x="4.5"
				y="4"
				width="24"
				height="24"
				rx="12"
				fill="#B5B5B9"/>
		</svg>
    
	);
}
